var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAttackButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 899,
    height: 109,
    viewBox: "0 0 899 109",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3_22260)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.6414 17L23.9948 70.7404H10L63.6466 17",
    fill: "#8DF6F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553.422 17L499.776 70.7404H485.781L539.428 17",
    fill: "#8DF6F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.521 17.2596L48.8743 71H34.8796L88.5262 17.2596",
    fill: "#8DF6F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.302 17.2596L524.655 71H510.661L564.307 17.2596",
    fill: "#8DF6F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.401 17.2595L73.7539 70.9999H59.7592L113.406 17.2595",
    fill: "#8DF6F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603.182 17.2595L549.535 70.9999H535.54L589.187 17.2595",
    fill: "#8DF6F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540.2 17.2595L486.553 70.9999H73.3345L126.981 17.2595",
    fill: "url(#paint0_linear_3_22260)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.097 59V30.68C208.097 29.528 208.369 28.488 208.913 27.56C209.489 26.6 210.241 25.848 211.169 25.304C212.129 24.728 213.185 24.44 214.337 24.44H236.369C237.521 24.44 238.577 24.728 239.537 25.304C240.497 25.848 241.249 26.6 241.793 27.56C242.369 28.488 242.657 29.528 242.657 30.68V59H237.425V46.904H213.281V59H208.097ZM213.281 41.72H237.425V30.824C237.425 30.504 237.313 30.232 237.089 30.008C236.865 29.752 236.593 29.624 236.273 29.624H214.481C214.161 29.624 213.873 29.752 213.617 30.008C213.393 30.232 213.281 30.504 213.281 30.824V41.72ZM254.222 59C253.07 59 252.014 58.712 251.054 58.136C250.126 57.56 249.374 56.808 248.798 55.88C248.254 54.952 247.982 53.912 247.982 52.76V22.376H253.166V31.16H264.59V36.344H253.166V52.616C253.166 52.936 253.278 53.224 253.502 53.48C253.758 53.704 254.046 53.816 254.366 53.816H264.59V59H254.222ZM274.8 59C273.648 59 272.592 58.712 271.632 58.136C270.704 57.56 269.952 56.808 269.376 55.88C268.832 54.952 268.56 53.912 268.56 52.76V22.376H273.744V31.16H285.168V36.344H273.744V52.616C273.744 52.936 273.856 53.224 274.08 53.48C274.336 53.704 274.624 53.816 274.944 53.816H285.168V59H274.8ZM295.658 59C294.506 59 293.45 58.712 292.49 58.136C291.562 57.56 290.81 56.808 290.234 55.88C289.69 54.952 289.418 53.912 289.418 52.76V42.488H312.506V37.544C312.506 37.224 312.394 36.952 312.17 36.728C311.946 36.472 311.674 36.344 311.354 36.344H289.418V31.16H311.498C312.65 31.16 313.69 31.448 314.618 32.024C315.578 32.568 316.33 33.32 316.874 34.28C317.45 35.24 317.738 36.28 317.738 37.4V59H295.658ZM295.802 53.816H312.506V47.336H294.602V52.616C294.602 52.936 294.714 53.224 294.938 53.48C295.194 53.704 295.482 53.816 295.802 53.816ZM328.047 59C326.895 59 325.855 58.712 324.927 58.136C323.999 57.56 323.247 56.808 322.671 55.88C322.095 54.952 321.807 53.912 321.807 52.76V37.4C321.807 36.248 322.095 35.208 322.671 34.28C323.247 33.352 323.999 32.6 324.927 32.024C325.855 31.448 326.895 31.16 328.047 31.16H350.031V36.344H328.191C327.871 36.344 327.583 36.472 327.327 36.728C327.103 36.952 326.991 37.224 326.991 37.544V52.616C326.991 52.936 327.103 53.224 327.327 53.48C327.583 53.704 327.871 53.816 328.191 53.816H350.127V59H328.047ZM354.248 59V22.04H359.432V42.488H365.672L376.088 31.16H382.04V32.12L370.28 45.08L382.04 58.04V59H376.088L365.672 47.672H359.432V59H354.248Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29 30L59 2H102",
    stroke: "white",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584 59L554 87L511 87",
    stroke: "white",
    strokeWidth: 3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3_22260",
    x: 0,
    y: 0.5,
    width: 909,
    height: 108,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3_22260"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3_22260",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3_22260",
    x1: 42.4396,
    y1: 71.1607,
    x2: 814.811,
    y2: 71.0007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DF6F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.341688,
    stopColor: "#FFAD29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.672144,
    stopColor: "#8DF6F5"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttackButton);
export default __webpack_public_path__ + "static/media/attack-button.7e853379367e7ba7482c371b298bca92.svg";
export { ForwardRef as ReactComponent };